module.exports = __webpack_public_path__ + "static/transaction_fee_management2@2x-6946395939df4c5e762eab6750bf5683.png";